var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { getTemplate } from '@progress/kendo-vue-common';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-vue-buttons';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { xIcon } from '@progress/kendo-svg-icons';
import { unaryOperator, stringOperator } from './operators';
import { messages, filterClose, filterExpressionDropdownAriaLabel, filterExpressionOperatorDropdownAriaLabel } from '../messages/main';
import { TextFilter } from './filters/TextFilter';
import { NumericFilter } from './filters/NumericFilter';
import { BooleanFilter } from './filters/BooleanFilter';
import { DateFilter } from './filters/DateFilter';
/**
 * @hidden
 */
var ExpressionVue2 = {
  name: 'KendoExpression',
  // @ts-ignore
  emits: {
    change: null,
    remove: null
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      required: true
    }
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var _this = this;
    var h = gh || createElement;
    var _a = this.$props,
      fields = _a.fields,
      filter = _a.filter;
    var field = fields.find(function (f) {
      return f.name === filter.field;
    });
    var locService = provideLocalizationService(this);
    var operators = (field && field.operators || []).map(function (o) {
      return __assign(__assign({}, o), {
        text: locService.toLanguageString(o.text, messages[o.text] || o.text)
      });
    });
    var defaultRendering = null;
    var filterEditors = function filterEditors(filterName, filterRender) {
      switch (filterName) {
        case 'numeric':
          defaultRendering =
          // @ts-ignore
          h(NumericFilter, {
            filter: filter,
            attrs: this.v3 ? undefined : {
              filter: filter
            },
            onFilterchange: this.onInputChange,
            on: this.v3 ? undefined : {
              "filterchange": this.onInputChange
            }
          });
          break;
        case 'date':
          defaultRendering =
          // @ts-ignore
          h(DateFilter, {
            filter: filter,
            attrs: this.v3 ? undefined : {
              filter: filter
            },
            onFilterchange: this.onInputChange,
            on: this.v3 ? undefined : {
              "filterchange": this.onInputChange
            }
          });
          break;
        case 'boolean':
          defaultRendering =
          // @ts-ignore
          h(BooleanFilter, {
            filter: filter,
            attrs: this.v3 ? undefined : {
              filter: filter
            },
            onFilterchange: this.onInputChange,
            on: this.v3 ? undefined : {
              "filterchange": this.onInputChange
            }
          });
          break;
        default:
          defaultRendering =
          // @ts-ignore
          h(TextFilter, {
            filter: filter,
            attrs: this.v3 ? undefined : {
              filter: filter
            },
            onFilterchange: this.onInputChange,
            on: this.v3 ? undefined : {
              "filterchange": this.onInputChange
            }
          });
          break;
      }
      return getTemplate.call(this, {
        h: h,
        template: filterRender,
        defaultRendering: defaultRendering,
        additionalProps: {
          filter: filter
        },
        additionalListeners: {
          filterchange: this.onInputChange
        }
      });
    };
    return h("div", {
      "class": "k-filter-toolbar"
    }, [
    // @ts-ignore function children 
    h(Toolbar, {
      keyboardNavigation: false,
      attrs: this.v3 ? undefined : {
        keyboardNavigation: false
      }
    }, this.v3 ? function () {
      return [
      // @ts-ignore function children 
      h(ToolbarItem, {
        "class": "k-filter-field"
      }, _this.v3 ? function () {
        return [
        // @ts-ignore 
        h(DropDownList, {
          "class": "k-filter-dropdown",
          dataItems: fields,
          attrs: _this.v3 ? undefined : {
            dataItems: fields,
            textField: "label",
            value: fields.find(function (f) {
              return f.name === filter.field;
            }),
            ariaLabel: locService.toLanguageString(filterExpressionDropdownAriaLabel, messages[filterExpressionDropdownAriaLabel])
          },
          textField: "label",
          value: fields.find(function (f) {
            return f.name === filter.field;
          }),
          onChange: _this.onFieldChange,
          on: _this.v3 ? undefined : {
            "change": _this.onFieldChange
          },
          ariaLabel: locService.toLanguageString(filterExpressionDropdownAriaLabel, messages[filterExpressionDropdownAriaLabel])
        })];
      } : [h(DropDownList, {
        "class": "k-filter-dropdown",
        dataItems: fields,
        attrs: _this.v3 ? undefined : {
          dataItems: fields,
          textField: "label",
          value: fields.find(function (f) {
            return f.name === filter.field;
          }),
          ariaLabel: locService.toLanguageString(filterExpressionDropdownAriaLabel, messages[filterExpressionDropdownAriaLabel])
        },
        textField: "label",
        value: fields.find(function (f) {
          return f.name === filter.field;
        }),
        onChange: _this.onFieldChange,
        on: _this.v3 ? undefined : {
          "change": _this.onFieldChange
        },
        ariaLabel: locService.toLanguageString(filterExpressionDropdownAriaLabel, messages[filterExpressionDropdownAriaLabel])
      })]),
      // @ts-ignore function children 
      h(ToolbarItem, {
        "class": "k-filter-operator"
      }, _this.v3 ? function () {
        return [
        // @ts-ignore
        h(DropDownList, {
          dataItems: operators,
          attrs: _this.v3 ? undefined : {
            dataItems: operators,
            textField: "text",
            value: operators.find(function (o) {
              return o.operator === filter.operator;
            }),
            ariaLabel: locService.toLanguageString(filterExpressionOperatorDropdownAriaLabel, messages[filterExpressionOperatorDropdownAriaLabel])
          },
          textField: "text",
          value: operators.find(function (o) {
            return o.operator === filter.operator;
          }),
          onChange: _this.onOperatorChange,
          on: _this.v3 ? undefined : {
            "change": _this.onOperatorChange
          },
          ariaLabel: locService.toLanguageString(filterExpressionOperatorDropdownAriaLabel, messages[filterExpressionOperatorDropdownAriaLabel])
        })];
      } : [h(DropDownList, {
        dataItems: operators,
        attrs: _this.v3 ? undefined : {
          dataItems: operators,
          textField: "text",
          value: operators.find(function (o) {
            return o.operator === filter.operator;
          }),
          ariaLabel: locService.toLanguageString(filterExpressionOperatorDropdownAriaLabel, messages[filterExpressionOperatorDropdownAriaLabel])
        },
        textField: "text",
        value: operators.find(function (o) {
          return o.operator === filter.operator;
        }),
        onChange: _this.onOperatorChange,
        on: _this.v3 ? undefined : {
          "change": _this.onOperatorChange
        },
        ariaLabel: locService.toLanguageString(filterExpressionOperatorDropdownAriaLabel, messages[filterExpressionOperatorDropdownAriaLabel])
      })]),
      // @ts-ignore function children 
      h(ToolbarItem, {
        "class": "k-filter-value"
      }, _this.v3 ? function () {
        return [field && filterEditors.call(_this, field.filter, field.filterRender)];
      } : [field && filterEditors.call(_this, field.filter, field.filterRender)]),
      // @ts-ignore function children 
      h(ToolbarItem, _this.v3 ? function () {
        return [
        // @ts-ignore
        h(Button, {
          title: locService.toLanguageString(filterClose, messages[filterClose]),
          attrs: _this.v3 ? undefined : {
            title: locService.toLanguageString(filterClose, messages[filterClose]),
            icon: "x",
            svgIcon: xIcon,
            look: "flat",
            type: "button"
          },
          icon: "x",
          svgIcon: xIcon,
          look: "flat",
          type: "button",
          onClick: _this.onFilterRemove,
          on: _this.v3 ? undefined : {
            "click": _this.onFilterRemove
          }
        })];
      } : [h(Button, {
        title: locService.toLanguageString(filterClose, messages[filterClose]),
        attrs: _this.v3 ? undefined : {
          title: locService.toLanguageString(filterClose, messages[filterClose]),
          icon: "x",
          svgIcon: xIcon,
          look: "flat",
          type: "button"
        },
        icon: "x",
        svgIcon: xIcon,
        look: "flat",
        type: "button",
        onClick: _this.onFilterRemove,
        on: _this.v3 ? undefined : {
          "click": _this.onFilterRemove
        }
      })])];
    } : [h(ToolbarItem, {
      "class": "k-filter-field"
    }, _this.v3 ? function () {
      return [h(DropDownList, {
        "class": "k-filter-dropdown",
        dataItems: fields,
        attrs: _this.v3 ? undefined : {
          dataItems: fields,
          textField: "label",
          value: fields.find(function (f) {
            return f.name === filter.field;
          }),
          ariaLabel: locService.toLanguageString(filterExpressionDropdownAriaLabel, messages[filterExpressionDropdownAriaLabel])
        },
        textField: "label",
        value: fields.find(function (f) {
          return f.name === filter.field;
        }),
        onChange: _this.onFieldChange,
        on: _this.v3 ? undefined : {
          "change": _this.onFieldChange
        },
        ariaLabel: locService.toLanguageString(filterExpressionDropdownAriaLabel, messages[filterExpressionDropdownAriaLabel])
      })];
    } : [h(DropDownList, {
      "class": "k-filter-dropdown",
      dataItems: fields,
      attrs: _this.v3 ? undefined : {
        dataItems: fields,
        textField: "label",
        value: fields.find(function (f) {
          return f.name === filter.field;
        }),
        ariaLabel: locService.toLanguageString(filterExpressionDropdownAriaLabel, messages[filterExpressionDropdownAriaLabel])
      },
      textField: "label",
      value: fields.find(function (f) {
        return f.name === filter.field;
      }),
      onChange: _this.onFieldChange,
      on: _this.v3 ? undefined : {
        "change": _this.onFieldChange
      },
      ariaLabel: locService.toLanguageString(filterExpressionDropdownAriaLabel, messages[filterExpressionDropdownAriaLabel])
    })]), h(ToolbarItem, {
      "class": "k-filter-operator"
    }, _this.v3 ? function () {
      return [h(DropDownList, {
        dataItems: operators,
        attrs: _this.v3 ? undefined : {
          dataItems: operators,
          textField: "text",
          value: operators.find(function (o) {
            return o.operator === filter.operator;
          }),
          ariaLabel: locService.toLanguageString(filterExpressionOperatorDropdownAriaLabel, messages[filterExpressionOperatorDropdownAriaLabel])
        },
        textField: "text",
        value: operators.find(function (o) {
          return o.operator === filter.operator;
        }),
        onChange: _this.onOperatorChange,
        on: _this.v3 ? undefined : {
          "change": _this.onOperatorChange
        },
        ariaLabel: locService.toLanguageString(filterExpressionOperatorDropdownAriaLabel, messages[filterExpressionOperatorDropdownAriaLabel])
      })];
    } : [h(DropDownList, {
      dataItems: operators,
      attrs: _this.v3 ? undefined : {
        dataItems: operators,
        textField: "text",
        value: operators.find(function (o) {
          return o.operator === filter.operator;
        }),
        ariaLabel: locService.toLanguageString(filterExpressionOperatorDropdownAriaLabel, messages[filterExpressionOperatorDropdownAriaLabel])
      },
      textField: "text",
      value: operators.find(function (o) {
        return o.operator === filter.operator;
      }),
      onChange: _this.onOperatorChange,
      on: _this.v3 ? undefined : {
        "change": _this.onOperatorChange
      },
      ariaLabel: locService.toLanguageString(filterExpressionOperatorDropdownAriaLabel, messages[filterExpressionOperatorDropdownAriaLabel])
    })]), h(ToolbarItem, {
      "class": "k-filter-value"
    }, _this.v3 ? function () {
      return [field && filterEditors.call(_this, field.filter, field.filterRender)];
    } : [field && filterEditors.call(_this, field.filter, field.filterRender)]), h(ToolbarItem, _this.v3 ? function () {
      return [h(Button, {
        title: locService.toLanguageString(filterClose, messages[filterClose]),
        attrs: _this.v3 ? undefined : {
          title: locService.toLanguageString(filterClose, messages[filterClose]),
          icon: "x",
          svgIcon: xIcon,
          look: "flat",
          type: "button"
        },
        icon: "x",
        svgIcon: xIcon,
        look: "flat",
        type: "button",
        onClick: _this.onFilterRemove,
        on: _this.v3 ? undefined : {
          "click": _this.onFilterRemove
        }
      })];
    } : [h(Button, {
      title: locService.toLanguageString(filterClose, messages[filterClose]),
      attrs: _this.v3 ? undefined : {
        title: locService.toLanguageString(filterClose, messages[filterClose]),
        icon: "x",
        svgIcon: xIcon,
        look: "flat",
        type: "button"
      },
      icon: "x",
      svgIcon: xIcon,
      look: "flat",
      type: "button",
      onClick: _this.onFilterRemove,
      on: _this.v3 ? undefined : {
        "click": _this.onFilterRemove
      }
    })])])]);
  },
  methods: {
    onFieldChange: function onFieldChange(event) {
      var nextFieldName = event.value.name;
      var nextField = this.$props.fields.find(function (f) {
        return f.name === nextFieldName;
      });
      var prevFilter = this.$props.filter;
      var operator = nextField && !nextField.operators.some(function (o) {
        return o.operator === prevFilter.operator;
      }) ? nextField.operators[0].operator : prevFilter.operator;
      var nextFilter = {
        field: nextFieldName,
        operator: operator
      };
      if (!unaryOperator(operator)) {
        nextFilter.value = stringOperator(operator) ? '' : null;
      }
      this.triggerOnFilterChange(prevFilter, nextFilter, event);
    },
    onOperatorChange: function onOperatorChange(event) {
      var operator = event.value.operator;
      var prevFilter = this.$props.filter;
      var nextFilter;
      if (unaryOperator(operator)) {
        var value = prevFilter.value,
          prevFilterNoValue = __rest(prevFilter, ["value"]);
        nextFilter = __assign(__assign({}, prevFilterNoValue), {
          operator: operator
        });
      } else {
        nextFilter = __assign(__assign({}, prevFilter), {
          operator: operator
        });
      }
      this.triggerOnFilterChange(prevFilter, nextFilter, event);
    },
    onInputChange: function onInputChange(event) {
      var prevFilter = this.$props.filter;
      var nextFilter = event.nextFilter;
      if (unaryOperator(nextFilter.operator)) {
        var field = this.$props.fields.find(function (f) {
          return f.name === nextFilter.field;
        });
        nextFilter = __assign(__assign({}, nextFilter), {
          operator: field && field.operators[0].operator || nextFilter.operator
        });
      }
      this.triggerOnFilterChange(prevFilter, nextFilter, event);
    },
    triggerOnFilterChange: function triggerOnFilterChange(prevFilter, nextFilter, event) {
      var changeEvent = {
        prevFilter: prevFilter,
        nextFilter: nextFilter,
        event: event.event,
        target: this
      };
      this.$emit('change', changeEvent);
    },
    onFilterRemove: function onFilterRemove(event) {
      var removeEvent = {
        filter: this.$props.filter,
        event: event.event,
        target: this
      };
      this.$emit('remove', removeEvent);
    }
  }
};
/**
 * @hidden
 */
var Expression = ExpressionVue2;
export { Expression, ExpressionVue2 };